import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Menu, X, LogIn, LogOut, BookOpen } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { FEATURES } from '../config/features';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout, isAdmin } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="home-container">
      {/* Header */}
      <header className="dark-header">
        <div className="logo-container" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
          <div className="logo-text">WestBay</div>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="dark-nav">
          <button onClick={() => scrollToSection('services')} className="dark-nav-link">Services</button>
          <button onClick={() => scrollToSection('about')} className="dark-nav-link">About</button>
          <button onClick={() => scrollToSection('poser-ai')} className="dark-nav-link">Poser AI™</button>
          <button onClick={() => scrollToSection('contact')} className="dark-nav-link">Contact</button>
          {FEATURES.BLOG_ENABLED && (
            <button onClick={() => navigate('/blog')} className="dark-nav-link">
              <BookOpen size={18} />
              <span>Blog</span>
            </button>
          )}
          {isAdmin && (
            <button onClick={() => navigate('/admin')} className="dark-nav-link admin-link">Admin</button>
          )}
          
          {isAuthenticated ? (
            <div className="nav-auth-section">
              <span className="nav-user-email">{user?.email}</span>
              <button onClick={logout} className="nav-logout-btn-clean" title="Sign out">
                <LogOut size={18} />
              </button>
            </div>
          ) : (
            <button onClick={() => navigate('/login')} className="nav-login-btn-clean" title="Sign in">
              <LogIn size={18} />
            </button>
          )}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </header>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => { scrollToSection('services'); setMobileMenuOpen(false); }} className="mobile-nav-link">Services</button>
          <button onClick={() => { scrollToSection('about'); setMobileMenuOpen(false); }} className="mobile-nav-link">About</button>
          <button onClick={() => { scrollToSection('poser-ai'); setMobileMenuOpen(false); }} className="mobile-nav-link">Poser AI™</button>
          {FEATURES.BLOG_ENABLED && (
            <button onClick={() => { navigate('/blog'); setMobileMenuOpen(false); }} className="mobile-nav-link">Blog</button>
          )}
          <button onClick={() => { scrollToSection('contact'); setMobileMenuOpen(false); }} className="mobile-nav-link">Contact</button>
          
          {isAuthenticated ? (
            <>
              {isAdmin && (
                <button onClick={() => { navigate('/admin'); setMobileMenuOpen(false); }} className="mobile-nav-link">Admin</button>
              )}
              <div className="mobile-nav-user">
                <span className="mobile-user-email">{user?.email}</span>
              </div>
              <button onClick={() => { logout(); setMobileMenuOpen(false); }} className="mobile-nav-link mobile-logout">
                <LogOut size={18} />
                <span>Logout</span>
              </button>
            </>
          ) : (
            <button onClick={() => { navigate('/login'); setMobileMenuOpen(false); }} className="mobile-nav-link mobile-login">
              <LogIn size={18} />
              <span>Login</span>
            </button>
          )}
        </div>
      )}

      {/* Main Content */}
      <main>
        {children}
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-single-line">
          <div className="footer-brand">
            <div className="logo-text">WestBay</div>
          </div>
          
          <div className="footer-center">
            <span className="body-small">© 2026 Westbay Group LLC. All rights reserved.</span>
            <span className="footer-separator">•</span>
            <button onClick={() => navigate('/privacy-policy')} className="footer-link">Privacy</button>
            <span className="footer-separator">•</span>
            <button onClick={() => navigate('/terms-of-service')} className="footer-link">Terms</button>
            <span className="footer-separator">•</span>
            <span className="footer-patent body-small">
              Poser AI™ • <span className="patent-text">Patent Pending</span>
            </span>
          </div>
          
          <button 
            onClick={() => {
              if (isAuthenticated) {
                navigate('/admin');
              } else {
                navigate('/admin/login');
              }
            }} 
            className="footer-shield-icon"
            title="Admin Dashboard"
          >
            <Shield size={24} />
          </button>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
